export interface INotificationSettingsReponse {
  Notifications: Array<INotification>;
}

export enum ENotificationChannel {
  None = 0,
  Email = 1,
  WebPush = 2,
  NotaNotification = 4,
}

export interface INotification {
  Id: string;
  Group?: string;
  Label: string;
  ActiveChannels: ENotificationChannel;
  Order: number;
  IsStatic: boolean;
}
